import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { build, pool } from 'src/app/common/classes/request-builder';
import { RequestHandler } from 'src/app/service/OffService/request-handler';
import { DashboardService } from 'src/app/service/events/dashboard.service';
import { ClienteAlbaranApiService, ObraApiService } from 'src/app/service/api/tablas-maestras-api.service';
import { BaseForm } from 'src/app/view/base-form';
import { ObraModel } from 'src/app/models/ventas/tablas-maestras.model';
import { ObraFormDefinition } from './form-control/form-definition';

@Component({
  selector: 'app-formulario-pulverizacion',
  standalone: false,
  templateUrl: './obra-form.component.html',
  styleUrls: ['./obra-form.component.scss'],
})
export class ObraFormComponent extends BaseForm<ObraModel> implements OnInit {
  public form!: ObraFormDefinition;
  public override model: ObraModel = {};
  public loadingData = true;
  public getRequest!: RequestHandler<ObraModel[]>;

  constructor(
    public override route: ActivatedRoute,
    public override dashboard: DashboardService,
    public override router: Router,
    public clientesApi: ClienteAlbaranApiService,
    public obraApi: ObraApiService,
  ) {
    super(
      route,
      router,
      dashboard,
      obraApi.obraPUT,
      obraApi.obraPOST,
      'obras',
      'Actualizar Obra',
      'Generar Obra',
      'Duplicar Obra',
    );

    this.getRequest = this.obraApi.obraGET;
  }

  public async ngOnInit(): Promise<void> {
    this.softInit(this.getType());
    this.form = new ObraFormDefinition(this.getType(), this.model);
    await this.initFormData();
  }

  private initFormData(): Promise<boolean> {
    this.loadingData = true;
    this.dropdownsFinalized = false;

    return pool([
      build(this.clientesApi.clienteGET, this.form.clientes, { or: ['razon_social', 'nombre'] }),
    ], () => this.dropdownLoadTrigger.next()).then(() => {
      this.loadingData = false;
      this.dropdownsFinalized = true;
      this.dropdownLoadTrigger.next();

      return true;
    }).catch((error: unknown) => {
      this.loadingData = false;
      this.dropdownsFinalized = true;
      this.dropdownLoadTrigger.next();
      console.error('Error loading obra form data.', error);

      return true;
    });
  }
}
